import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "currency-amount-map" }
const _hoisted_2 = ["disabled", "value", "onChange"]
const _hoisted_3 = ["value", "disabled"]
const _hoisted_4 = ["disabled", "value", "onInput"]
const _hoisted_5 = ["disabled", "onClick"]
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rows, (row, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: row.key,
        class: "currency-amount-map__row d-flex align-items-center mb-1"
      }, [
        _createElementVNode("select", {
          class: "form-select currency-amount-map__currency",
          disabled: _ctx.disabled,
          value: row.currency,
          onChange: ($event: any) => (_ctx.onCurrencyChange(index, $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (currency) => {
            return (_openBlock(), _createElementBlock("option", {
              key: currency,
              value: currency,
              disabled: _ctx.isCurrencyTaken(currency, index)
            }, _toDisplayString(currency), 9, _hoisted_3))
          }), 128))
        ], 40, _hoisted_2),
        _createElementVNode("input", {
          class: "form-control currency-amount-map__amount ms-2",
          type: "text",
          inputmode: "decimal",
          disabled: _ctx.disabled,
          value: row.amount,
          onInput: ($event: any) => (_ctx.onAmountInput(index, $event))
        }, null, 40, _hoisted_4),
        (_ctx.rows.length > 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              type: "button",
              class: "btn btn-outline-secondary btn-sm ms-2",
              disabled: _ctx.disabled,
              onClick: _withModifiers(($event: any) => (_ctx.removeRow(index)), ["prevent"])
            }, _cache[1] || (_cache[1] = [
              _createElementVNode("i", { class: "fa fa-times" }, null, -1)
            ]), 8, _hoisted_5))
          : _createCommentVNode("", true),
        (index === _ctx.rows.length - 1)
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              type: "button",
              class: "btn btn-outline-primary btn-sm ms-2",
              disabled: _ctx.disabled || !_ctx.canAddRow,
              onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.addRow && _ctx.addRow(...args)), ["prevent"]))
            }, _cache[2] || (_cache[2] = [
              _createElementVNode("i", { class: "fa fa-plus" }, null, -1)
            ]), 8, _hoisted_6))
          : _createCommentVNode("", true)
      ]))
    }), 128))
  ]))
}